/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = "is-active";
	const v = "is-visible";
	const _pagepath = "/case/";

	const introductionSlide = () => {
		const introductionSlider = document.querySelector(".mod-introductionSlide");
		if (introductionSlider) {
			const slideItems = introductionSlider.querySelectorAll(".splide__slide");
	
			const splide = new Splide(".mod-introductionSlide.splide", {
				type: "loop",
				perPage: 1,
				autoplay: false,
				interval: 5000,
				speed: 500,
				arrows: slideItems.length > 1, // スライドが1つなら矢印を非表示
				pagination: true,
				paginationKeyboard: true,
			}).mount();
		}
	};

	const pickupSlide = () => {
		const pickupSlider = document.querySelector(".mod-pickupSlide");
		if (pickupSlider) {
			const slideItems = pickupSlider.querySelectorAll(".splide__slide");
	
			const splide = new Splide(".mod-pickupSlide.splide", {
				type: "loop",
				perPage: 1,
				autoplay: false,
				interval: 5000,
				speed: 500,
				arrows: slideItems.length > 1, // スライドが1つなら矢印を非表示
				pagination: true,
				paginationKeyboard: true,
			}).mount();
		}
	};

	const pickupCatInsert = () => {
		const getJSONfiles = () => "/ajax/news/list.json";
	
		const insertTags = (data) => {
			const items = document.querySelectorAll(".rt_key");
	
			items.forEach((item) => {
				const rtKeyValue = item.textContent.trim(); // rt_key の値を取得
	
				const matchedData = data.rt_bn_news_list.find((news) => {
					return news._key === rtKeyValue; // JSON の _key と一致するかチェック
				});
	
				if (matchedData) {
					const tagElement = item
						.closest(".__item")
						.querySelector(".js-category");
					if (tagElement) {
						// cf_n_related_solutions 内の cf_nt_name_d を全て取得し、#で連結
						const relatedSolutions = matchedData.cf_n_related_solutions.map(
							(solution) => `${solution.cf_nt_name_d}`
						).join(" ");
						
						// タグ要素に設定
						tagElement.textContent = relatedSolutions;
					}
				}
			});
		};
	
		fetch(getJSONfiles())
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((data) => {
				insertTags(data);
			})
			.catch((error) => {
				console.error("Error fetching JSON data:", error);
			});
	};

	const solutionCheckboxInsert = () => {
		const getJSONfiles = () => `/ajax/solution/list.json`;
		const getNewsFiles = () => `/ajax/case/caselist.json`;
	
		fetch(getJSONfiles())
			.then((response) => response.json())
			.then((solutionData) => {
				fetch(getNewsFiles())
					.then((response) => response.json())
					.then((newsData) => {
						const largeCatContainer = document.querySelector(".js-solutionLargecat");
						const smlCatContainer = document.querySelector(".js-solutionSmlcat");
						const catContainer = document.querySelector(".js-solutionCat");
						const solutionListContainer = document.querySelector(".js-solutionList");
	
						let checkBoxId = 1;
	
						const appendCheckboxes = (container, groupCode) => {
							if (!container) {
								console.error(`Container for groupCode ${groupCode} not found.`);
								return;
							}
	
							const filteredData = solutionData.rt_bn_solution_list.filter(
								(item) => item.cf_nt_group_code === groupCode
							);
							filteredData.forEach((item) => {
								const label = document.createElement("label");
								label.className = "mod-checkbox";
								label.setAttribute("for", `check_${checkBoxId}`);
	
								const input = document.createElement("input");
								input.type = "checkbox";
								input.name = "check";
								input.id = `check_${checkBoxId}`;
								input.value = item._key;
	
								// Set initial state from URL parameters
								const urlParams = new URLSearchParams(window.location.search);
								if (urlParams.get(`check_${checkBoxId}`) === item.cf_nt_name_d) {
									input.checked = true;
								}
	
								input.addEventListener("change", () => {
									filterNews(newsData);
									updateQueryParams();
								});
	
								const span = document.createElement("span");
								span.className = "mod-checkbox-text";
								span.textContent = item.cf_nt_name_d;
	
								label.appendChild(input);
								label.appendChild(span);
								container.appendChild(label);
								checkBoxId++;
							});
						};
	
						const filterNews = (newsData) => {
							const selectedValues = Array.from(
								document.querySelectorAll('input[name="check"]:checked')
							).map((input) => input.value);
							let filteredNews = newsData.rt_bn_case_list;
							if (selectedValues.length > 0) {
								filteredNews = newsData.rt_bn_case_list.filter((newsItem) =>
									newsItem.cf_n_tags.some((tag) =>
										selectedValues.includes(tag._key)
									)
								);
							}
							renderNewsList(filteredNews);
							renderPagination(filteredNews);
						};
	
						const renderPagination = (filteredNews) => {
							const paginationContainer = document.getElementById("pagination");
							const itemsPerPage = 12;
							const totalPages = Math.ceil(filteredNews.length / itemsPerPage);
						
							if (totalPages <= 1) {
								paginationContainer.style.display = "none";
								return;
							}
						
							paginationContainer.style.display = "flex";
							paginationContainer.innerHTML = "";
						
							for (let i = 1; i <= totalPages; i++) {
								const li = document.createElement("li");
								const a = document.createElement("a");
								a.href = "#";
								a.textContent = i;
								a.addEventListener("click", (e) => {
									e.preventDefault();
									renderPage(i, true);
								});
								li.appendChild(a);
								paginationContainer.appendChild(li);
							}
						
							const nextLi = document.createElement("li");
							const nextA = document.createElement("a");
							nextA.href = "#";
							nextA.textContent = "›";
							nextA.addEventListener("click", (e) => {
								e.preventDefault();
								const currentPage = parseInt(
									paginationContainer.querySelector(".active a")?.textContent || "1"
								);
								if (currentPage < totalPages) {
									renderPage(currentPage + 1, true);
								}
							});
							nextLi.appendChild(nextA);
							paginationContainer.appendChild(nextLi);
						
							const lastLi = document.createElement("li");
							const lastA = document.createElement("a");
							lastA.href = "#";
							lastA.textContent = "»";
							lastA.addEventListener("click", (e) => {
								e.preventDefault();
								renderPage(totalPages, true);
							});
							lastLi.appendChild(lastA);
							paginationContainer.appendChild(lastLi);
						
							const renderPage = (page, isUserAction = false) => {
								const startIndex = (page - 1) * itemsPerPage;
								const endIndex = page * itemsPerPage;
								const pageItems = filteredNews.slice(startIndex, endIndex);
								renderNewsList(pageItems);
						
								if (isUserAction) {
									document.getElementById("c-list").scrollIntoView({ behavior: "smooth" });
								}
						
								const paginationLinks = paginationContainer.querySelectorAll("a");
								paginationLinks.forEach((link, index) => {
									if (index + 1 === page) {
										link.parentElement.classList.add("active");
									} else {
										link.parentElement.classList.remove("active");
									}
								});
							};
						
							renderPage(1, false);
						};
						
	
						const renderNewsList = (newsList) => {
							solutionListContainer.innerHTML = "";
	
							newsList.forEach((newsItem) => {
								const listItem = document.createElement("li");
								listItem.className = "__column_3 __column_tab_2 __column_sp_1";
	
								const link = document.createElement("a");
								link.href = `/case/detail/${newsItem._key}.html`;
	
								const picture = document.createElement("picture");
								const img = document.createElement("img");
								img.src = newsItem.cf_n_thum_img
									? `/news/news_file/file/${newsItem.cf_n_thum_img}`
									: "/common/images/thumbnail.jpg";
								img.alt = newsItem.cf_n_thum_img_alt || "";
								img.className = "width-u-100";
								picture.appendChild(img);
								link.appendChild(picture);
	
								const txtBox = document.createElement("div");
								txtBox.className = "txtBox";
	
								const title = document.createElement("p");
								title.className = "_ttl mod-spacer_16";
								title.textContent = newsItem.cf_n_title;
								txtBox.appendChild(title);
	
								const company = document.createElement("p");
								company.className = "_company mod-spacer_16";
								company.textContent = newsItem.cf_n_company_name || "";
								txtBox.appendChild(company);
	
								link.appendChild(txtBox);
								listItem.appendChild(link);
	
								const tagList = document.createElement("ul");
								tagList.className = "mod-tags mod-spacer_16";
	
								newsItem.cf_n_tags.forEach((tag) => {
									const tagItem = document.createElement("li");
	
									const tagLink = document.createElement("a");
									tagLink.href = `/case/tag/${tag.cf_nt_url}/`;
	
									const tagSpan = document.createElement("span");
									tagSpan.className = "__tag";
									tagSpan.textContent = `${tag.cf_nt_name_d}`;
	
									tagLink.appendChild(tagSpan);
									tagItem.appendChild(tagLink);
									tagList.appendChild(tagItem);
								});
	
								listItem.appendChild(tagList);
								solutionListContainer.appendChild(listItem);
							});
						};
	
						const updateQueryParams = () => {
							const url = new URL(window.location.href);
							const checkboxes = document.querySelectorAll(
								'input[name="check"]'
							);
							checkboxes.forEach((checkbox) => {
								const label = checkbox.nextElementSibling;
								if (checkbox.checked) {
									url.searchParams.set(checkbox.id, label.textContent);
								} else {
									url.searchParams.delete(checkbox.id);
								}
							});
							window.history.replaceState({}, "", url);
						};
	
						// Append checkboxes to the respective containers
						appendCheckboxes(largeCatContainer, "case_category");
						appendCheckboxes(smlCatContainer, "case_category2");
						appendCheckboxes(catContainer, "case_solution");
	
						// Initial render of all news items
						filterNews(newsData);
					})
					.catch((error) => console.error("Error fetching news JSON:", error));
			})
			.catch((error) => console.error("Error fetching solution JSON:", error));
	};
	
	const solutionDetailList = async () => {
		const fetchJSON = async () => {
		  const response = await fetch(`/ajax/case/list.json`);
		  return response.json();
		};
	  
		try {
		  const data = await fetchJSON();
	  
		  const currentKey = window.location.pathname.match(/\/case\/detail\/(.*)\.html/)[1];
	  
		  const currentCase = data.rt_bn_case_list.find(item => item._key === currentKey);
	  
		  if (!currentCase) return;
	  
		  const currentTags = currentCase.cf_n_tags.map(tag => tag._key);
	  
		  const matchedCases = data.rt_bn_case_list
			.filter(item => item._key !== currentKey)
			.map(item => {
			  const matchedTagCount = item.cf_n_tags.filter(tag => currentTags.includes(tag._key)).length;
			  return { ...item, matchedTagCount };
			})
			.filter(item => item.matchedTagCount > 0)
			.sort((a, b) => {
			  if (b.matchedTagCount === a.matchedTagCount) {
				return new Date(b.cf_n_date) - new Date(a.cf_n_date);
			  }
			  return b.matchedTagCount - a.matchedTagCount;
			})
			.slice(0, 3);
	  
		  const ul = document.querySelector('.js-solutionDetailList');
	  
		  if (!ul) return;
	  
		  if (matchedCases.length === 0) {
			// If no matched cases, hide the parent container
			const solutionDetailSection = document.querySelector('.js-solutionDetail');
			if (solutionDetailSection) {
			  solutionDetailSection.style.display = 'none';
			}
			return;
		  }
	  
		  ul.innerHTML = matchedCases
			.map(item => {
			  const title = item.cf_n_title || '';
			  const companyName = item.cf_n_company_name || '';
			  const imageSrc = item.cf_n_thum_img
				? `/news/news_file/file/${item.cf_n_thum_img}`
				: '/images/dummy/dummy.png';
			  const caseUrl = `/case/detail/${item._key}.html`;
	  
			  const tagsHTML = item.cf_n_tags
				.map(tag => {
				  const tagUrl = `/case/tag/${tag.cf_nt_url}/`;
				  const tagName = tag.cf_nt_name_d || '';
				  return `<li><a href="${tagUrl}"><span class="__tag">${tagName}</span></a></li>`;
				})
				.join('');
	  
			  return `
				<li class="__column_3 __column_tab_2 __column_sp_1">
				  <a href="${caseUrl}">
					<picture>
					  <img src="${imageSrc}" alt="" class="width-u-100">
					</picture>
					<div class="txtBox">
					  <p class="_ttl mod-spacer_16">${title}</p>
					  <p class="_company mod-spacer_16">${companyName}</p>
					</div>
				  </a>
				  <ul class="mod-tags mod-spacer_16">${tagsHTML}</ul>
				</li>
			  `;
			})
			.join('');
		} catch (error) {
		  console.error('エラー:', error);
		}
	};
	  

	pickupCatInsert();
	introductionSlide();
	pickupSlide();
	solutionCheckboxInsert();
	solutionDetailList();
})(window.FUNCTIONS);
